//mobile footer menu

$('.footer-block--menu .footer-block__heading').on('click', function(){
    $(this).siblings().toggleClass('footer-block--menu-open');
    $(this).toggleClass("footer-block--heading-open");
})

//Animate on scroll initiation
$(function() {
    AOS.init(); // Animation AOS library init
});
// Wish list (Dream list) - Inject print button
$(document).on("click",".preheader_links[href='#swym-wishlist']",function(event){
  var changeFlag = true
  if (changeFlag){
    var intervalFn = setInterval(function (){
      if ($('.swym-wishlist-context-menu').length == 1){
        $('.swym-wishlist-context-menu.swym-icon.swym-is-button').click()
        if ( $('#dreamlist_print_btn').length == 0){
          $('.swym-wishlist-detail-header').append('<button onClick="printPageArea(`dreamlist`)" id="dreamlist_print_btn" class="btn swym-wishlist-context-menu-item swym-print swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span><span>Print / Save</span></button>')
          changeFlag = false;
          clearInterval(intervalFn)
          // console.log('interval.. ')
        }
      }
    }, 500);
  }
})
  
  
function printPageArea(area = null){
  if (area == 'dreamlist'){
    $('body').addClass('printarea_dreamlist')
  }else{
    $('body').removeClass('printarea_dreamlist')
  }
  window.print()
}



function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// waitForElm('.strmpr-search-result-filters').then((elm) => {
//   setTimeout(function() { 
//   $('.strmpr-filter-toggle-name-0 label').click();
//   }, 1000);
// });




$(document).ready(function(){
  // Initialize searchable select for store locations
  if ($('#EnquireForm-preferred-store').length > 0) {
    $('#EnquireForm-preferred-store').select2({
      placeholder: "Select a store...",
      allowClear: false,
      width: '100%',
      dropdownParent: $('#EnquireForm-preferred-store').parent()
    });
  }
  
  // Initialize searchable select for contact form store locations
  if ($('#ContactForm-preferred-store').length > 0) {
    $('#ContactForm-preferred-store').select2({
      placeholder: "Select a store...",
      allowClear: false,
      width: '100%',
      dropdownParent: $('#ContactForm-preferred-store').parent()
    });
  }
  
  // on Product page
  // if ($('.js-zoom-enabled').length > 0 || (window.innerWidth < 750 && $('.pt.product__media.enable_zoom_lightbox').length > 0) ){
  //   $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //   $('.js-zoom-enabled').each( function(){
  //     let zoomUrl = $(this).data('zoom');
  //     $(this).zoom({
  //       url: zoomUrl
  //     });
  //   })
  // }
  // $(window).resize(function() {
  //   if ( window.innerWidth < 750 ) {
  //     $('.pt.product__media.enable_zoom_lightbox').addClass('js-zoom-enabled');
  //     $('.enable_zoom_lightbox.js-zoom-enabled').each( function(){
  //       let zoomUrl = $(this).data('zoom');
  //       $(this).zoom({
  //         url: zoomUrl
  //       });
  //     })
  //   }else {
  //     $('.pt.product__media.enable_zoom_lightbox').removeClass('js-zoom-enabled');
  //   }
  // })

  // Product template Okendo review section - Jun 2024
  $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').hide(); // 1. Hide okendo review first
  // 2. Show if the section has slider content. 
  waitForElm('.template-product .okeReviews .oke-reviewCarousel-slider').then((elm) => {
    $('.template-product div[id^="shopify-block-okendo_reviews_carousel_"]').show();
  });

  $('.preheader_links').on('click', function(){
    console.log('wishlist');
    var existCondition = setInterval(function() {
      if ($('.swym-value').length) {
        console.log("Exists!");
         clearInterval(existCondition);
        
        $('.swym-value').each(function(){
           var thisText = $(this).text();
           $(this).text('');

           var removeNZD = thisText.slice(3, -3);
      
           $(this).empty();
            $(this).text('$'+removeNZD);
           //console.log(removeNZD);
        });
         
       

      }
     }, 600); // check every 100ms
  });

  // Global - Announcement bar slider
  // if ( $(window).width() < 990 ) {
  //   // active Slider
  //   announcementBarMobileSlider()
  // } else {
  //   // destory slider
  //   disableMobileCarousel('#shopify-section-announcement-bar')
  // }
  announcementBarMobileSlider()
});


  $(function() {


    $('body').on('click', '.variant-wrapper', function(){
      $('.variant-picker').toggle();
      $('.size-option-variant .ico').toggle();
      $('#size-selector').addClass('hidden')
      $('#btn-product-size').removeClass('btn-icon')
    });

    $('body').on('click', '.product-size-selector-wrapper', function(){
      console.log('product-size-selector-wrapper');
      $('.variant-picker').hide(); 
      $('.size-option-variant .ico').hide();
    });

   

    $('body').on('click', '.variant-picker li ', function(){
      console.log('clicked');
      let getVID = $(this).data('vid');
      window.history.replaceState(null, null, `?variant=${getVID}`);
      location.reload();
    });

    if (window.location.href.indexOf("variant") > -1) {
      getVarName = $('.ul-selected').text();
      $('.variant-name').text(getVarName);
    } else {
      getVarName = $('.variant-picker li').first().text();
      $('.variant-name').text(getVarName);
    }
  });

// new announcement bar slider
// $(window).resize(function() {
//   if ( $(window).width() < 990 ) {
//     // active Slider
//     announcementBarMobileSlider()
//   } else {
//     // destory slider
//     disableMobileCarousel('#shopify-section-announcement-bar')
//   }
// })

function announcementBarMobileSlider(){
  let x = '#shopify-section-announcement-bar';
  $(x).addClass('owl-carousel').addClass('owl-theme');
  $(x).owlCarousel({
    loop: true,
    dots: false,
    autoWidth: false,
    autoHeight: false,
    items:1,
    nav: false,
    autoplay:true,
    // autoplayTimeout:3000,
    autoplayHoverPause:true,
    animateOut: 'slideOutUp',
    animateIn: 'slideInUp', 
    
    // smartSpeed:3000
  })
  // .trigger('refresh.owl.carousel');
}

function disableMobileCarousel(x){
  $(x).trigger('destroy.owl.carousel');
  $(x).removeClass('owl-carousel');
}

// Check if the device is a mobile device
function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
}

// Function to add slick slider to elements with class .js-mobile-slider
function addSlickSliderToMobile() {
    if (isMobileDevice()) {
        $('.js-mobile-slider').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 2.5,
                slidesToScroll: 3,
                dots: true,
                centerMode: true,
                adaptiveHeight: true
            });
        });
        $('.js-mobile-slider-none-overlap').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                dots: true,
            });
        });
        $('.js-mobile-slider-single-item').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 3,
                slidesToScroll: 3,                
                dots: true,
            });
        });
        $('.js-mobile-slider-one-per').each(function() {
            $(this).slick({
                // Slick slider options
                slidesToShow: 1,
                slidesToScroll: 1,                
                dots: true,
            });
        });
    }
}

// Execute the function when the DOM is ready
$(document).ready(function() {
    addSlickSliderToMobile();
});



$(document).ready(function() {
    $('.mega-menu').mouseenter(function() {
        $(this).attr('open', '');
        $('.slideshow__controls').hide();
    });

    $('.mega-menu').mouseleave(function() {
        $(this).removeAttr('open');
        $('.slideshow__controls').show();
    });
});

// window.addEventListener('scroll', function() {
//   var body = document.body;
//   var scrollPosition = window.scrollY;
//   var scrollThreshold = window.innerWidth <= 768 ? 50 : 1; // Adjust threshold for mobile devices
  
//   if (scrollPosition > scrollThreshold) {
//     body.classList.add('fixed-header');
//   } else {
//     body.classList.remove('fixed-header');
//   }
// });

function paymentsWidget(e){
  let isActive = $(e).hasClass('active') ? true : false;

  if (isActive){
    $(e).removeClass('active') // hide 
  }else {
    $(e).addClass('active')// Show
  }
}

function customDecreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) - 1

  let minQty = 1
  
  // Check maximum value and block if it's over the max value
  if (currentQty <= minQty){
    // console.log('1 is the minimum !!')
    return false;
  }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function customIncreaseItem(product){
  let widgetID = ($(event.target).parents('.rebuy-widget').attr('id')).replaceAll('rebuy-widget-', '')
  let pID = product.id;
  let selectBox = $(event.target).parents('.qty-custom-wrap').find('.custom-dynamic-bundle-qty-select')
  let qtyInput = $(event.target).parents('.product-quantity').find('.custom-dynamic-bundle-qtyinput')
  let currentQty = selectBox.val()
  let updatedQty = (1*currentQty) + 1

  let maxQty = selectBox.find('option').length
  
  // Check maximum value and block if it's over the max value
  if (currentQty >= maxQty){
    // console.log('max value reached !!!')
    return false;
  }
  // Update (hidden) select box
  selectBox.val(updatedQty).trigger('change')
  qtyInput.text(`${updatedQty}`)

  updateRebuyWidget(widgetID, pID, updatedQty);
}

function updateRebuyWidget(widgetID, pID, updatedQty){
  console.log('updateRebuyWidget ->',widgetID, pID, updatedQty)

  let widgetList = Rebuy.widgets

  widgetList.forEach((e)=>{
    if (e.id == widgetID){
      let products = e.data.products;
      products.forEach((p)=>{
        if (p.id == pID){
          p.quantity = updatedQty
          console.log('!!!!!!', p.id, p.quantity)
        }
      });
    }
  })
}


// Product form submission
let productApiDataSubmitted = false;
const ZYBER_URL = 'https://bedsrus.com.au/apps/gadget';
const SECURITY_KEY = '2NkZ18ALQS962c5zsexIwTdwrUBZkl4kse6IyhPvqEJM5H8C8hAfySDnjiYpxIu7918xEZKFxhqxtu5EtZslKKZInZZOVQTNECwoI3q6ZhVfnqwnZasWRl29MXdb';

function productFormSubmission(obj, e) {
  if (!productApiDataSubmitted) {
    e.preventDefault();

    var first = $(obj).closest('form').find('[name="contact[first_name]"]').val(),
        last = $(obj).closest('form').find('[name="contact[last_name]"]').val(),
        email = $(obj).closest('form').find('[name="contact[email]"]').val(),
        phone = $(obj).closest('form').find('[name="contact[phone]"]').val(),
        streetAddress = $(obj).closest('form').find('[name="contact[street_address]"]').val(),
        city = $(obj).closest('form').find('[name="contact[city]"]').val(),
        postcode = $(obj).closest('form').find('[name="contact[postcode]"]').val(),
        preferredStore = $(obj).closest('form').find('[name="contact[preferred_store]"]').val(),
        selection = $(obj).closest('form').find('[name="contact[selection]"]').val(),
        message = $(obj).closest('form').find('[name="contact[message]"]').val(),
        optedIn = $(obj).closest('form').find('[name="contact[permission]"]').is(':checked'),
        product = $(obj).closest('form').find('[name="contact[submitted]"]').val();
    
    // Format phone number before validation
    var formattedPhone = formatPhoneNumber(phone); // Format the phone number
    var phoneValid = phoneValidation(formattedPhone); // Validate the formatted phone number
    var emailValid = emailValidation(email); // Validate the email

    // Remove previous error messages and styles
    $('input, textarea').removeClass('error'); // Remove the error class
    $('.error-message').remove(); // Remove any existing error messages

    // Track validation status
    var isValid = true;

    // Check for missing fields and validation errors
    if (!first) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[first_name]"]').addClass('error').after('<span class="error-message" style="color: red;">First name is required.</span>');
    }
    if (!email) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[email]"]').addClass('error').after('<span class="error-message" style="color: red;">Email is required.</span>');
    }
    if (!phoneValid) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[phone]"]').addClass('error').after('<span class="error-message" style="color: red;">Please enter a valid mobile number.</span>');
    }
    if (!streetAddress) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[street_address]"]').addClass('error').after('<span class="error-message" style="color: red;">Street address is required.</span>');
    }
    if (!city) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[city]"]').addClass('error').after('<span class="error-message" style="color: red;">City is required.</span>');
    }
    if (!postcode) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[postcode]"]').addClass('error').after('<span class="error-message" style="color: red;">Postcode is required.</span>');
    }
    if (!preferredStore) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[preferred_store]"]').addClass('error').after('<span class="error-message" style="color: red;">Preferred store is required.</span>');
    }
    if (!selection) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[selection]"]').addClass('error').after('<span class="error-message" style="color: red;">Product selection is required.</span>');
    }
    if (!message) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[message]"]').addClass('error').after('<span class="error-message" style="color: red;">Message is required.</span>');
    }

    // If validation fails, stop form submission
    if (!isValid) {
      return; // Prevent form submission
    }

    // If validation passes, prepare data for submission
    var params = {
      "firstName": first,
      "lastName": last,
      "email": email,
      "phone": formattedPhone,  // Use the formatted phone number
      "streetAddress": streetAddress,
      "city": city,
      "postcode": postcode,
      "preferredStore": preferredStore,
      "selection": selection,
      "message": message,
      "product": product,
      "optedIn": optedIn ? 1 : 0
    };

    console.log("#######--------", params);

    // Set flag to prevent multiple submissions while AJAX is in progress
    productApiDataSubmitted = true;

    $.ajax({
      type: 'POST',
      url: ZYBER_URL + '/api/form-submission/product-enquiry',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(params),
      headers: {
        'x-api-key': SECURITY_KEY
      }
    }).done(function(response) {
      console.log('#productFormSubmission Ajax - response:', response);
      // Remove any existing success messages before adding a new one
      $('.success-message').remove();
      $('.product-enquire-form').hide(); // Hide form
      $('.product-enquire-form').after('<div class="success-message"><span style="font-size: 24px;font-family: TextaAlt-Bold, sans-serif; margin-bottom: 15px; color: #0b4470;">Thank You for your enquiry!</span><br> <p style="text-align: center; font-size: 14px; font-weight: 400;">One of our team members will be in touch with you shortly</p></div>'); // Show success message
   
      $('#submit_contactForm').click();
    }).fail(function(jqXHR, textStatus) {
      console.log('#productFormSubmission Ajax - failed:', jqXHR, textStatus);
      // Reset flag on failure to allow retry
      productApiDataSubmitted = false;
      // Remove any existing error messages before adding a new one
      $('.error-message').remove();
      $('#EnquireForm').before('<div class="error-message"> <p style="text-align: center; font-size: 14px; font-weight: 400;">An error has occurred. Please try again.</p></div>');
    });
  }
}

let contactApiDataSubmitted = false;
function contactFormSubmission(obj, e) {
  if (!contactApiDataSubmitted) {
    e.preventDefault();

    var first = $(obj).closest('form').find('[name="contact[first_name]"]').val(),
        last = $(obj).closest('form').find('[name="contact[last_name]"]').val(),
        email = $(obj).closest('form').find('[name="contact[email]"]').val(),
        phone = $(obj).closest('form').find('[name="contact[phone]"]').val(),
        preferredStore = $(obj).closest('form').find('[name="contact[preferred_store]"]').val(),
        message = $(obj).closest('form').find('[name="contact[message]"]').val(),
        emailValid = emailValidation(email);

    // Format the phone number before validation
    var formattedPhone = formatPhoneNumber(phone);
    var phoneValid = phoneValidation(formattedPhone);

    // Remove previous error messages and styles
    $('input, textarea').removeClass('error');
    $('.error-message').remove();

    // Track validation status
    var isValid = true;

    // Ensure required fields are filled and valid
    if (!first) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[first_name]"]').addClass('error').after('<span class="error-message" style="color: red;">First name is required.</span>');
    }
    if (!email) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[email]"]').addClass('error').after('<span class="error-message" style="color: red;">Email is required.</span>');
    } else if (!emailValid) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[email]"]').addClass('error').after('<span class="error-message" style="color: red;">Please enter a valid email address.</span>');
    }
    if (!phoneValid) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[phone]"]').addClass('error').after('<span class="error-message" style="color: red;">Please enter a valid mobile number.</span>');
    }
    if (!preferredStore) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[preferred_store]"]').addClass('error').after('<span class="error-message" style="color: red;">Preferred store is required.</span>');
    }
    if (!message) {
      isValid = false;
      $(obj).closest('form').find('[name="contact[message]"]').addClass('error').after('<span class="error-message" style="color: red;">Message is required.</span>');
    }

    // If validation fails, stop form submission
    if (!isValid) {
      return;
    }

    // If validation passes, prepare data for submission
    var params = {
      "firstName": first,
      "lastName": last,
      "email": email,
      "phone": formattedPhone,
      "preferredStore": preferredStore,
      "message": message
    };

    // Set flag to prevent multiple submissions while AJAX is in progress
    contactApiDataSubmitted = true;

    $.ajax({
      type: 'POST',
      url: ZYBER_URL + '/api/form-submission/contact-us',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(params),
      headers: {
        'x-api-key': SECURITY_KEY
      }
    }).done(function(response) {
      // Remove any existing success messages before adding a new one
      $('.success-message').remove();
      $('#ContactForm').trigger("reset");
      $('#ContactForm').hide();
      $('#ContactForm').after('<div class="success-message"><span style="font-size: 24px;font-family: TextaAlt-Bold, sans-serif; margin-bottom: 15px; color: #0b4470;">Thank You for your enquiry!</span><br> <p style="text-align: center; font-size: 14px; font-weight: 400;">One of our team members will be in touch with you shortly</p></div>');

    }).fail(function(jqXHR, textStatus) {
      // Reset flag on failure to allow retry
      contactApiDataSubmitted = false;
      
      // Remove any existing error messages before adding a new one
      $('.error-message').remove();
      $('#ContactForm').before('<div class="error-message"> <p style="text-align: center; font-size: 14px;font-weight: 400;">An error has occurred. Please try again.</p></div>');
    });
  }
}

// Format the phone number before passing it to validation
function formatPhoneNumber(phone) {
    var formattedPhone = phone.trim();

    // Ensure the phone starts with +61 and remove leading zero if necessary
    if (!formattedPhone.startsWith("+61")) {
        formattedPhone = "+61" + formattedPhone.replace(/^0+/, ""); // Add +61 and remove any leading zeros if not already present
    }

    // If the phone starts with +61 and the next character is 0, remove that 0
    if (formattedPhone.startsWith("+61") && formattedPhone.charAt(3) === "0") {
        formattedPhone = "+61" + formattedPhone.slice(4); // Remove the leading 0 after +61
    }

    console.log('Formatted Phone Number:', formattedPhone); // Log formatted phone number

    return formattedPhone;
}

// Email validation function
function emailValidation(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
  return re.test(String(email).toLowerCase());
}

// Phone validation function
function phoneValidation(phone) {
    console.log('Phone to validate:', phone); // Debugging line

    // Validate the phone number format using a regex for +61 and 9 digits after it
    const phoneFormatRegex = /^\+61\d{9}$/; // Phone number should start with +61 and exactly 9 digits after

    // Check if the phone number matches the required format and length
    if (phoneFormatRegex.test(phone)) {
        console.log('Phone validation passed:', phone); // Log successful validation
        return true; // Valid phone number
    } else {
        console.log('Phone validation failed:', phone); // Log failed validation
        return false; // Invalid phone number
    }
}

 



